
import React from 'react';
import { useLayout } from "@/contexts/LayoutContext";
import { useNavigate, useLocation } from 'react-router-dom';

const SidebarHeader: React.FC = () => {
  const { sidebarMode, setSidebarMode } = useLayout();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleToggleMode = (mode: 'workspace' | 'curso') => {
    setSidebarMode(mode);
    
    if (mode === 'workspace') {
      navigate('/status-prioridades');
    } else if (mode === 'curso') {
      navigate('/index');
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold text-[#2E80EC]">
        <img 
          src="https://images.clickfunnels.com/cdn-cgi/image/width=600,fit=scale-down,f=auto,q=80/https://statics.myclickfunnels.com/workspace/vMBPdQ/image/8940270/file/0459b0402696fe26ae4e3444caa5b2d7.png" 
          alt="Revenue Hub Logo" 
          className="h-8 max-w-[180px] object-contain"
        />
      </h2>
      {sidebarMode === 'workspace' && (
        <p className="text-sm text-[#4A5568]">Organiza tareas y apuntes</p>
      )}
      {sidebarMode === 'curso' && (
        <p className="text-sm text-[#14182B]">Programa de crecimiento comercial</p>
      )}

      <div className="px-0 mt-4">
        <div className="flex h-10 items-center rounded-md bg-[#E1E5EB] p-1">
          <button
            onClick={() => handleToggleMode('workspace')}
            className={`flex-1 flex items-center justify-center gap-2 rounded-sm py-1.5 text-sm font-medium transition-all ${
              sidebarMode === 'workspace' 
                ? 'bg-[#2E80EC] text-white shadow-sm' 
                : 'text-[#4A5568] hover:text-[#14182B]'
            }`}
          >
            <span role="img" aria-label="brain" className="text-lg">🧠</span>
            Focus Space
          </button>
          <button
            onClick={() => handleToggleMode('curso')}
            className={`flex-1 flex items-center justify-center gap-2 rounded-sm py-1.5 text-sm font-medium transition-all ${
              sidebarMode === 'curso' 
                ? 'bg-[#2E80EC] text-white shadow-sm' 
                : 'text-[#4A5568] hover:text-[#14182B]'
            }`}
          >
            <span role="img" aria-label="money face" className="text-lg">🤑</span>
            Focus Flow
          </button>
        </div>
      </div>
    </div>
  );
};

export default SidebarHeader;
